import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectQueryFilters = (store: StoreSchema) => store.licenseEvents.queryFilter
export const selectUpdateTimeFrom = (store: StoreSchema) => store.licenseEvents.filter.updateTimeFrom
export const selectUpdateTimeTo = (store: StoreSchema) => store.licenseEvents.filter.updateTimeTo